export const APP_COLOR = "#79b5d1"
export const BACKGROUND = "76, 104, 117"
export const BACKGROUND_COLOR = "rgb(" + BACKGROUND + ", 0.65)"
export const BUTTON_BACKGROUND = BACKGROUND_COLOR
export const BUTTON_HOVER =  "rgb(" + BACKGROUND + ", 1)"
export const BUTTON_TEXT_COLOR = "#f5fcff"
export const BUTTON_FONT = "Roboto Slab, serif"
export const SHADOW_WIDTH = "0.3em"
export const SHADOW = "0.1em 0.1em " + SHADOW_WIDTH + " rgb(0, 0, 0, 0.5)"
export const SONG_PREVIEW_HEIGHT = "10%"
export const FADE_IN = 1
export const NAV_BAR_HEIGHT = "5%"
export const ELASTIC_EASE = "elastic.out(1.2, 1)"

